import React, { useContext, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';

import ProjectPage from '../Project';
import EditProcedure from '../EditProcedure';

import {
  RouterContext,
  RouterContextData,
} from '../../containers/RouterProviders';

export const isViewOnlyRedirect = (route: RouterContextData) =>
  (route.location.from?.search.includes('viewOnly') &&
    !route.location.to?.search.includes('viewOnly') &&
    route.location.to?.pathname.includes('project')) ||
  false;

const ProjectRoutes = () => {
  const route = useContext(RouterContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isViewOnlyRedirect(route)) {
      navigate(`${route.location.to?.pathname}?viewOnly=true`, {
        replace: true,
      });
    }
  }, [route, navigate]);

  return (
    <Routes>
      <Route path=":id" element={<ProjectPage />} />
      <Route path="edit/:id" element={<EditProcedure />} />
    </Routes>
  );
};

export default ProjectRoutes;
